import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { ShiftSection } from './components/ShiftSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { BonusesSection } from './components/BonusesSection';
import { WhoSection } from './components/WhoSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CTASection } from './components/CTASection';
import { FinalCloseSection } from './components/FinalCloseSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-teal-100 selection:text-slate-800" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <ShiftSection data-id="element-4" />
        <WhatYouGetSection data-id="element-5" />
        <BonusesSection data-id="element-6" />
        <WhoSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <CTASection data-id="element-9" />
        <FinalCloseSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}